"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GridLayout = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _GridLayout = require("./GridLayout.styles");
var _excluded = ["layout"];
var LAYOUT_TEMPLATES = {
  fluid12: 'repeat(12, minmax(0, 1fr))',
  fixed12: 'repeat(auto-fit, 88px)',
  auto: 'repeat(auto-fit, minmax(0, 1fr))'
};

/**
 * Grid layout is a specialized grid container used to quickly create a grid using common grid
 * configurations. Common configurations usually include definitions for gaps and column templates.
 *
 * This component extends the `Grid` component which
 * has limited support for IE11. See the `Grid`
 * component for more details.
 *
 * @extends Grid
 * @since 8.22.0
 */
var GridLayout = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, forwardedRef) {
  var layout = _ref.layout,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var addProps = {};
  var template = LAYOUT_TEMPLATES[layout];
  if (template) {
    addProps.gridTemplateColumns = template;
  }
  return /*#__PURE__*/_react.default.createElement(_GridLayout.StyledGridLayout, (0, _extends2.default)({
    ref: forwardedRef
  }, addProps, rest));
});
exports.GridLayout = GridLayout;
GridLayout.displayName = 'GridLayout';
GridLayout.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * The `display` prop from `Grid`.
   */
  display: _propTypes.default.oneOf(['grid', 'inline-grid']),
  /**
   * The `gap` prop from `Grid`.
   */
  gap: _propTypes.default.string,
  /**
   * The `justifyContent` prop from `Grid`.
   */
  justifyContent: _propTypes.default.oneOf(['start', 'end', 'center', 'stretch', 'space-around', 'space-between', 'space-evenly']),
  /**
   * A pre-defined grid template configuration.
   *
   * Note: `fixed12` and `auto` layouts use `auto-fit` which is not supported by IE11.
   * If you need to support IE11, use `fluid12` or specify your own `gridTemplateColumns` using
   * the `Grid` component.
   */
  layout: _propTypes.default.oneOf(['fluid12', 'fixed12', 'auto'])
} : {};
GridLayout.defaultProps = {
  display: 'grid',
  gap: 'sm',
  justifyContent: 'center',
  layout: 'fluid12'
};